import React from 'react';
import {Box} from '@material-ui/core';

interface TabPanelProps {
  value: number;
  index: number;
  PanelProps?: object;
  BoxProps?: object;
  children: React.ReactNode
}

export const TabPanel = (props: TabPanelProps) => {
  const {PanelProps={}, BoxProps={}, value, index} = props;

  const visible = value === index;

  return (
    <React.Fragment>
      {visible && <div
        role="tabpanel"
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...PanelProps}
      >
        <Box p={3} {...BoxProps}>
          {props.children}
        </Box>
      </div>}
    </React.Fragment>
  );
};

export const TabProps = (index) => {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
};